module.exports = __webpack_public_path__ + "static/media/send.ff96bf1b.svg";